import type { Page } from "@sveltejs/kit";
import {
	buildCanonical,
	buildPageTitle,
	DEFAULT_DESCRIPTION,
} from "./constants";
import { getStaticPageSeo } from "./static-page-seo";
import type { PageSeo } from "./types";

type PageDataWithSeo = {
	seo?: PageSeo;
};

export function resolvePageSeo(page: Page): PageSeo {
	const pageData = page.data as PageDataWithSeo;

	if (pageData.seo) {
		return pageData.seo;
	}

	const staticSeo = getStaticPageSeo(page.url.pathname);
	if (staticSeo) {
		return staticSeo;
	}

	return {
		title: buildPageTitle(),
		description: DEFAULT_DESCRIPTION,
		canonical: buildCanonical(page.url.pathname),
	};
}
